import { TranslateService } from '@ngx-translate/core';
import { CompanyFlagTypeEntity } from '@nk/data-entities-lib';

export function sortCompanyFlag<T extends Pick<CompanyFlagTypeEntity, 'company_flag_type_key'>>(
  companyFlagTypeList: T[],
  translateService: TranslateService,
): T[] {
  return companyFlagTypeList.slice().sort((a, b) => {
    if (a.company_flag_type_key.includes('fsa_license') && b.company_flag_type_key.includes('fsa_license')) {
      return a.company_flag_type_key.localeCompare(b.company_flag_type_key);
    } else if (a.company_flag_type_key.includes('fsa_license')) {
      return 1;
    } else if (b.company_flag_type_key.includes('fsa_license')) {
      return -1;
    }
    const aTitle = translateService.instant('company_flag.' + a.company_flag_type_key);
    const bTitle = translateService.instant('company_flag.' + b.company_flag_type_key);
    return aTitle.localeCompare(bTitle, 'nb');
  });
}
